var menu = document.querySelector('.menu');

[ ...document.querySelectorAll('.toggle-menu') ].forEach( el => {
    el.addEventListener( 'click', e => {
        e.preventDefault();
        menu.classList.toggle( 'txy-100100' );
        menu.classList.toggle( 'pen' );
    })
})